import type { ReactNode } from "react";

import { CROWDFUNDING_URL } from "../../data/siteContent";
import { Button } from "./Button";

type BuyButtonVariant = "primary" | "secondary" | "ghost" | "gold";

type BuyButtonProps = {
  children: ReactNode;
  variant?: BuyButtonVariant;
  className?: string;
};

export function BuyButton({
  children,
  variant = "secondary",
  className,
}: BuyButtonProps) {
  return (
    <Button
      href={CROWDFUNDING_URL}
      variant={variant}
      className={className}
      newTab
    >
      {children}
    </Button>
  );
}
